$(function () {

    var projectCardWrapper = $('.project_phase_row');

    if (projectCardWrapper.length < 1) {
        return;
    }

    projectCardWrapper.align({
        selector: '.project_phase_column__bottom *'
    });

});